module.exports = __webpack_public_path__ + "static/media/pexels-1.f5af8c38.jpg";